import { createResourceModule } from '../../../lib/resource/module.js';
import { exchangeRateDetailSchema } from './schemas.js';

export const exchangeRates = createResourceModule({
  resource: 'exchangeRates',
  basePath: '/v1/exchange-rates',
  detail: exchangeRateDetailSchema,
});

export const exchangeRateEndpoints = exchangeRates.endpoints;
